import { RouteInfo } from "@/common/RouteInfo";

export enum Paths {
  Dashboard,
  PurchaseReports,
  UserAccounts,
  Stores,
  Receipts,
  StoreReceipts,
  Products,
  DataUploader,
  Offers,
  Allergens,
  SeasonalHeader,
  ProductLocation,
  ClickAndCollect,
  ClickAndCollectOrders,
  ClickAndCollectPickOrder,
  ClickAndCollectCollectOrder,
  UserAdministration,
  About,
  AisleCategory,
  AisleCategoryAdd,
  AisleCategoryEdit,
}

export const RouteInfoMap: Map<Paths, RouteInfo> = new Map<Paths, RouteInfo>([
  [Paths.Dashboard, { path: "/", name: "Dashboard" }],
  [Paths.PurchaseReports, { path: "/purchase-reports", name: "PurchaseReports" }],
  [Paths.UserAccounts, { path: "/user-accounts", name: "UserAccounts" }],
  [Paths.Stores, { path: "/stores", name: "Stores" }],
  [Paths.Receipts, { path: "/receipts", name: "Receipts" }],
  [Paths.StoreReceipts, { path: "/store-receipts", name: "StoreReceipts" }],
  [Paths.Products, { path: "/products", name: "Products" }],
  [Paths.DataUploader, { path: "/data-uploader", name: "DataUploader" }],
  [Paths.Offers, { path: "/offers", name: "Offers" }],
  [Paths.Allergens, { path: "/allergens", name: "Allergens" }],
  [Paths.SeasonalHeader, { path: "/seasonal-header", name: "SeasonalHeader" }],
  [Paths.ProductLocation, { path: "/product-location", name: "ProductLocation" }],

  [Paths.ClickAndCollect, { path: "/click-and-collect", name: "PPSlotBookings" }],
  [Paths.ClickAndCollectOrders, { path: "/click-and-collect/fulfillments", name: "PPOrderList" }],
  [
    Paths.ClickAndCollectPickOrder,
    { path: "/click-and-collect/fulfillments/:transactionId/pick", name: "PPPickOrder" },
  ],
  [
    Paths.ClickAndCollectCollectOrder,
    { path: "/click-and-collect/fulfillments/:transactionId/collect", name: "PPCollectOrder" },
  ],

  [Paths.UserAdministration, { path: "/user-administration", name: "UAUserList" }],
  [Paths.About, { path: "/about", name: "About" }],
  [Paths.AisleCategory, { path: "/aisle-category", name: "AisleCategory" }],
  [Paths.AisleCategoryAdd, { path: "/aisle-category/add", name: "AisleCategoryAdd" }],
  [Paths.AisleCategoryEdit, { path: "/aisle-category/:aisleCategoryId", name: "AisleCategoryEdit" }],
]);
